"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchUsernameButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var withState_1 = require("../hocs/withState");
exports.SearchUsernameButton = (0, withState_1.withState)()([
    "setSearchParams",
]).memoFC(function (state) { return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { icon: true, size: "mini", onClick: function () {
        state.setSearchParams({ name: "username", value: state.username });
    }, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "search" }) })); });
